"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModerateGrowth;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ModerateGrowth() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "158",
    height: "155",
    viewBox: "0 0 158 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "79",
    cy: "77.125",
    rx: "75",
    ry: "73.125",
    stroke: "#059469",
    strokeWidth: "8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M138.5 33.9998C113 -5.00012 54 -2.5001 28 23.9999C11.5 36.4999 4 57.6391 4 76.9999C4 96.3607 11.9018 114.929 25.967 128.619C40.0322 142.309 59.1088 150 79 150",
    stroke: "#802AB8",
    strokeWidth: "8",
    strokeMiterlimit: "16",
    strokeLinecap: "round",
    strokeDasharray: "0.5 0.5"
  }));
}